import React, { useState } from 'react';
import { 
  Table, Card, Button, Space, Typography, Modal, Form, 
  Input, Select, Tag, Badge, Alert, Cascader, Descriptions
} from 'antd';
import { SearchOutlined, ReloadOutlined, PlusOutlined, SwapOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;
const { Option } = Select;

const cloudOptions = [
  { value: 'V2', label: 'V2', children: [
    { value: 'cn-v2-01', label: 'China-V2-Main (cn-v2-01)', region: '国内' },
    { value: 'ap-v2-01', label: 'AsiaPacific-V2 (ap-v2-01)', region: '亚太' },
    { value: 'na-v2-01', label: 'NorthAmerica-V2 (na-v2-01)', region: '北美' },
  ]},
  { value: 'V3', label: 'V3', children: [
    { value: 'cn-v3-01', label: 'China-V3-Main (cn-v3-01)', region: '国内' },
    { value: 'cn-v3-02', label: 'China-V3-Backup (cn-v3-02)', region: '国内' },
    { value: 'ap-v3-01', label: 'AsiaPacific-V3 (ap-v3-01)', region: '亚太' },
    { value: 'na-v3-01', label: 'NorthAmerica-V3 (na-v3-01)', region: '北美' },
  ]},
];

const getCloudInfo = (val) => {
  if (!val || val.length < 2) return null;
  const ver = cloudOptions.find(v => v.value === val[0]);
  const cloud = ver?.children?.find(c => c.value === val[1]);
  return cloud ? { version: val[0], cloudName: cloud.label.split(' (')[0], cloudId: val[1], region: cloud.region } : null;
};

const mockEnterprises = { 'JGSf0Nd7': '东莞康林物联网有限公司', 'A619355x': '捷顺科技股份有限公司', 'HM-8827-X': '深圳汇云科技', 'test': '测试企业' };
const mockProducts = {
  'JGSf0Nd7': [{ value: 'PROD_Q1', label: '智能摄像机Q1' }, { value: 'PROD_CAM2', label: '户外摄像机C2' }],
  'A619355x': [{ value: 'PROD_PC1', label: 'ParkingCloud传感器' }],
  'HM-8827-X': [{ value: 'PROD_P1', label: '云台机P1' }, { value: 'PROD_S2', label: '智能门锁S2' }],
  'test': [{ value: 'PROD_T1', label: '测试产品T1' }],
};

const ProductDispatch = () => {
  const [form] = Form.useForm();
  const [addForm] = Form.useForm();
  const [addVisible, setAddVisible] = useState(false);
  const [selectedEnt, setSelectedEnt] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [targetInfo, setTargetInfo] = useState(null);

  const dataSource = [
    { key: '1', entName: '东莞康林物联网有限公司', entId: 'JGSf0Nd7', prodName: '智能摄像机Q1', prodId: 'PROD_Q1', beforeRegion: '国内', targetVersion: 'V3', targetCloudName: 'China-V3-Main', targetCloudId: 'cn-v3-01', afterRegion: '国内', status: 'success', operator: 'admin', time: '2026-04-01 10:00:00' },
    { key: '2', entName: '深圳汇云科技', entId: 'HM-8827-X', prodName: '云台机P1', prodId: 'PROD_P1', beforeRegion: '国内', targetVersion: 'V2', targetCloudName: 'AsiaPacific-V2', targetCloudId: 'ap-v2-01', afterRegion: '亚太', status: 'failed', operator: 'admin', time: '2026-03-28 14:30:00' },
    { key: '3', entName: '捷顺科技股份有限公司', entId: 'A619355x', prodName: 'ParkingCloud传感器', prodId: 'PROD_PC1', beforeRegion: '亚太', targetVersion: 'V3', targetCloudName: 'NorthAmerica-V3', targetCloudId: 'na-v3-01', afterRegion: '北美', status: 'success', operator: 'HM_finance', time: '2026-03-25 09:00:00' },
  ];

  const regionColor = { '国内': 'blue', '亚太': 'green', '北美': 'orange' };

  const columns = [
    { title: '企业信息', key: 'ent', width: 200, render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.entName}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.entId}</Text></div>) },
    { title: '调度产品', key: 'prod', width: 180, render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.prodName}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.prodId}</Text></div>) },
    { title: '调度目标', key: 'target', width: 180, render: (_, r) => (<div><Tag>{r.targetVersion}</Tag><div style={{ fontSize: 13 }}>{r.targetCloudName}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.targetCloudId}</Text></div>) },
    { title: '调度后区域', dataIndex: 'afterRegion', width: 100, render: (v) => <Tag color={regionColor[v]}>{v}</Tag> },
    { title: '状态', dataIndex: 'status', width: 100, render: (s) => s === 'success' ? <Badge status="success" text="调度成功" /> : <Badge status="error" text="调度失败" /> },
    { title: '操作人', dataIndex: 'operator', width: 80 },
    { title: '操作时间', dataIndex: 'time', width: 170, render: (t) => <Text type="secondary">{t}</Text> },
  ];

  const handleEntChange = (val) => {
    const name = mockEnterprises[val];
    setSelectedEnt(name ? { id: val, name } : null);
    setSelectedProduct(null);
    addForm.setFieldsValue({ productId: undefined, target: undefined });
    setTargetInfo(null);
  };

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 16 }}><Title level={4}>产品调度</Title></div>

      <Card bordered={false} style={{ marginBottom: 8, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Form form={form} layout="inline" style={{ flex: 1 }}>
            <Form.Item>
              <Space.Compact>
                <Form.Item name="entType" initialValue="name" noStyle><Select style={{ width: 100 }}><Option value="name">企业名称</Option><Option value="id">企业ID</Option></Select></Form.Item>
                <Form.Item shouldUpdate={(p, c) => p.entType !== c.entType} noStyle>
                  {({ getFieldValue }) => (<Form.Item name="ent" noStyle><Input placeholder={getFieldValue('entType') === 'id' ? "请输入企业ID" : "请输入企业名称"} allowClear style={{ width: 180 }} /></Form.Item>)}
                </Form.Item>
              </Space.Compact>
            </Form.Item>
            <Form.Item>
              <Space.Compact>
                <Form.Item name="prodType" initialValue="name" noStyle><Select style={{ width: 100 }}><Option value="name">产品名称</Option><Option value="id">产品ID</Option></Select></Form.Item>
                <Form.Item shouldUpdate={(p, c) => p.prodType !== c.prodType} noStyle>
                  {({ getFieldValue }) => getFieldValue('prodType') === 'id'
                    ? <Form.Item name="prodValue" noStyle><Input placeholder="请输入产品ID" allowClear style={{ width: 160 }} /></Form.Item>
                    : <Form.Item name="prodValue" noStyle><Select placeholder="请选择产品" style={{ width: 160 }} allowClear showSearch optionFilterProp="label" options={[{ value: 'PROD_Q1', label: '智能摄像机Q1' }, { value: 'PROD_CAM2', label: '户外摄像机C2' }, { value: 'PROD_P1', label: '云台机P1' }, { value: 'PROD_S2', label: '智能门锁S2' }]} /></Form.Item>
                  }
                </Form.Item>
              </Space.Compact>
            </Form.Item>
            <Form.Item name="status"><Select placeholder="状态" style={{ width: 120 }} allowClear><Option value="success">调度成功</Option><Option value="failed">调度失败</Option></Select></Form.Item>
            <Form.Item><Space><Button type="primary" icon={<SearchOutlined />}>查询</Button><Button icon={<ReloadOutlined />} onClick={() => form.resetFields()}>重置</Button></Space></Form.Item>
          </Form>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => { addForm.resetFields(); setSelectedEnt(null); setSelectedProduct(null); setTargetInfo(null); setAddVisible(true); }}>发起产品调度</Button>
        </div>
      </Card>

      <Card bordered={false}>
        <Table columns={columns} dataSource={dataSource} rowKey="key" scroll={{ x: 1200 }}
          pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }} />
      </Card>

      {/* 发起产品调度 */}
      <Modal title={<Space><SwapOutlined style={{ color: '#1890ff' }} /><span>发起产品调度</span></Space>}
        open={addVisible} onOk={async () => { try { await addForm.validateFields(); Modal.confirm({ title: '确认执行产品调度？', content: '调度操作不可撤销，请确认信息无误。', onOk() { setAddVisible(false); } }); } catch(e){} }}
        onCancel={() => setAddVisible(false)} okText="立即执行" cancelText="取消" destroyOnClose width={600}
      >
        <Form form={addForm} layout="vertical" style={{ marginTop: 16 }}>
          <Form.Item name="enterpriseId" label="选择企业" rules={[{ required: true, message: '请选择企业' }]}>
            <Select placeholder="请输入企业名称搜索" showSearch optionFilterProp="children" onChange={handleEntChange}>
              {Object.entries(mockEnterprises).map(([id, name]) => <Option key={id} value={id}>{name}</Option>)}
            </Select>
          </Form.Item>
          {selectedEnt && (
            <div style={{ background: '#fafafa', padding: '8px 12px', borderRadius: 6, marginBottom: 16 }}>
              <Text type="secondary" style={{ fontSize: 12 }}>企业ID：</Text><Text copyable>{selectedEnt.id}</Text>
            </div>
          )}
          <Form.Item noStyle shouldUpdate={(p, c) => p.enterpriseId !== c.enterpriseId}>
            {({ getFieldValue }) => {
              const entId = getFieldValue('enterpriseId');
              if (!entId || !mockProducts[entId]) return null;
              return (
                <Form.Item name="productId" label="选择调度产品" rules={[{ required: true, message: '请选择产品' }]}>
                  <Select placeholder="请选择产品" showSearch optionFilterProp="label" options={mockProducts[entId]}
                    onChange={(val) => setSelectedProduct(mockProducts[entId]?.find(p => p.value === val))}
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
          {selectedProduct && (
            <>
              <div style={{ background: '#fafafa', padding: '8px 12px', borderRadius: 6, marginBottom: 16 }}>
                <Text type="secondary" style={{ fontSize: 12 }}>产品ID：</Text><Text copyable>{selectedProduct.value}</Text>
              </div>
              <Descriptions bordered column={1} size="small" style={{ marginBottom: 16 }}>
                <Descriptions.Item label="调度前信息">
                  <Space><Tag>V2</Tag><Text>—</Text><Text>China-V2-Main</Text><Text>—</Text><Text style={{ fontFamily: 'monospace' }}>cn-v2-01</Text><Tag color="blue">国内</Tag></Space>
                </Descriptions.Item>
              </Descriptions>
            </>
          )}
          <Form.Item name="target" label="调度目标" rules={[{ required: true, message: '请选择调度目标' }]}>
            <Cascader options={cloudOptions} placeholder="请选择 V2/V3 → Cloud" onChange={(val) => setTargetInfo(getCloudInfo(val))} />
          </Form.Item>
          {targetInfo && (
            <div style={{ marginBottom: 16 }}>
              <div style={{ background: '#f6ffed', padding: '8px 12px', borderRadius: 6, border: '1px solid #b7eb8f', marginBottom: 8 }}>
                <Text type="secondary" style={{ fontSize: 12 }}>所属区域：</Text><Tag color={regionColor[targetInfo.region]}>{targetInfo.region}</Tag>
              </div>
              <Alert type="warning" showIcon message="切换调度目标可能会导致短暂的服务中断，请在业务低峰期操作调度。" style={{ borderRadius: 6 }} />
            </div>
          )}
        </Form>
      </Modal>
    </div>
  );
};

export default ProductDispatch;
